export const liabilityOverallReport = async ({ firm, list  }) => {
    let pdfDoc = {
        // pageOrientation: 'landscape',
        content: [
            {
                table: {
                    widths: ['30%', '70%' ],
                    body: [
                        [
                            {
                                text: 'COMMON REPORT ', style: 'schoolColorHeader2'
                            },

                            {
                                text:
                                    [
                                        { text: '          ', bold: true, style: 'schoolColorHeader' },
                                        { text: '\n', style: 'schoolColorHeader' },
                                        // { text: '          ', bold: true, style: 'schoolDetails' },
                                        // { text: '\n', style: 'schoolDetails' },
                                        // { text: 'AFFILIATION NUMBER    :  ', bold: true, style: "schoolDetails" },
                                        // { text: '\n', style: "schoolDetails" },
                                        // { text: 'SCHOOL CODE              :  ', bold: true, style: "schoolDetails" },
                                        // { text: '\n', style: "schoolDetails" },
                                        // { text: 'CONTACT NUMBER                 :   ', bold: true, style: 'schoolDetails' },
                                        // { text: '\n', style: "schoolDetails" },
                                    ]
                            },
                        ],
                    ],

                },
                layout: {
                    hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 2 : 0;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 2 : 0;
                    },
                    hLineColor: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 'black' : 'white';
                    },
                    vLineColor: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 'black' : 'white';
                    },
                }
            },
            {
                table: {
                    headerRows: 1,
                    widths: ['10%', "*", '15%', '15%', '15%', '15%'],
                    body: [
                        [
                            { text: 'S.No.', style: "schoolColorHeader1" },
                            { text: 'Staff', style: "schoolColorHeader1" },
                            { text: 'Debit (₹)', style: "schoolColorHeader1" },
                            { text: 'Credit (₹)', style: "schoolColorHeader1" },
                            { text: 'Running Balance (₹)', style: "schoolColorHeader1" },
                            { text: 'Remark', style: "schoolColorHeader1" },
                        ],

                    ]
                },
            },
            {
                table: {
                    widths: ['33%', '34%', '33%'],
                    body: [
                        [
                            {
                                text:
                                    [
                                        { text: '\n\n\n\n' },
                                        { text: 'OFFICE INCHARGE ', bold: true, alignment: 'center',style: 'colorHeader'},
                                        { text: '\n' },                                                                                    
                                    ]
                            },
                        
                            {
                                text:
                                [
                                    { text: '\n\n\n\n' },
                                    { text: 'AUTHORITY SIGNATURE  ', bold: true, alignment: 'center',style: 'colorHeader'},
                                    { text: '\n' },
                                ]
                            },

                            {
                                text:
                                    [
                                        { text: '\n\n\n\n' },
                                        { text: 'PRINCIPAL SIGNATURE  ', bold: true, alignment: 'center',style: 'colorHeader'},
                                        { text: '\n' },                                                                                    
                                    ]
                            },
                        ],
                    ],
                
                },
                layout : {
                        hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 2 : 0;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 2 : 0;
                    },
                    hLineColor: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 'black' : 'white';
                    },
                    vLineColor: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 'black' : 'white';
                    },
                }
            },

        ],
        styles: {
            feeHeader: {
                fontSize: 10,
                alignment: 'center'
            },
            feeTableHeader: {
                fontSize: 10,
                alignment: 'center',
                fillColor: '#1A237E',
                color: '#ffffff',
                bold: true,
            },
            feeDescriptiveHeader: {
                fontSize: 10,
                alignment: 'left',
                bold: true,
            },
            feeDescriptiveHeader1: {
                fontSize: 10,
                alignment: 'center',
                bold: true,
            },
            topHeader: {
                color: '#ffffff',
                fontSize: 11,
                alignment: 'left',
                bold: true,
                fillColor: '#1A237E'
            },
            thankyouHeader: {
                color: '#ffffff',
                fontSize: 11,
                alignment: 'center',
                bold: true,
                fillColor: '#1A237E'
            },
            upcomingFeeHeader: {
                color: '#ffffff',
                fontSize: 11,
                alignment: 'left',
                bold: true,
                fillColor: '#1A237E'
            },
            colorHeader: {
                color: '#1A237E',
                fontSize: 12,
                bold: true,
            },
            schoolColorHeader: {
                color: '#1A237E',
                fontSize: 14,
                bold: true,
                alignment: 'right',
            },
            schoolColorHeader1: {
                color: '#1A237E',
                fontSize: 9,
                bold: true,
                alignment: 'center',
            },
            schoolColorHeader2: {
                color: '#1A237E',
                fontSize: 14,
                bold: true,
                alignment: 'left',
            },
            studentDetails: {
                fontSize: 9,
                bold: true,
            },
            studentDetailsRight: {
                fontSize: 9,
                bold: true,
            },
            studentIncreaseFontDetails: {
                fontSize: 12,
                bold: true,
            },
            studentIncreaseFontAmountDetails: {
                fontSize: 12,
                bold: true,
                color: '#1A237E',
            },
            studentBlankDetails: {
                fontSize: 20,
                bold: true,
                color: '#ffffff',
            },
            schoolDetails: {
                fontSize: 10,
                bold: true,
                alignment: 'right'
            },
            thankyouMsg: {
                color: '#1A237E',
                fontSize: 12,
                bold: true,
                alignment: 'center',
            }
        }
    }

    //school details

    if (firm) {
        pdfDoc.content[0].table.body[0][1].text[1].text = ('BMJ').toUpperCase() + '\n';
        // pdfDoc.content[0].table.body[0][1].text[3].text = (school.address || '') + '\n';
        // pdfDoc.content[0].table.body[0][1].text[5].text = (school.boardAffiliationNumber || '') + '\n';
        // pdfDoc.content[0].table.body[0][1].text[7].text = (school.schoolCode || '') + '\n';
        // pdfDoc.content[0].table.body[0][1].text[9].text = (school.mobile || '') + '\n';
    }

    // pdfDoc.content[0].table.body[0][0].text += `[${selectedExpense}]`


    let runningBalance = 0;
    let debitTotal = 0;
    let creditTotal = 0;

    list.forEach((pro, index) => {
        let isDebit = pro.type === 'liability';
        let debit = isDebit ? Number(pro.amount) : 0;
        let credit = !isDebit ? Number(pro.amount) : 0;

        // Update totals
        debitTotal += debit;
        creditTotal += credit;

        // Update running balance
        runningBalance += debit - credit;

        pdfDoc.content[1].table.body.push([
            { text: index + 1, style:'studentDetails' },
            { text: pro.staffName || '', style: 'studentDetails' },
            { text: debit ? debit.toFixed(2) : '500000.25', style: 'studentDetails' },
            { text: credit ? credit.toFixed(2) : '500000.25', style: 'studentDetails' },
            { text: '500000.25', style: 'studentDetails' },
            { text: pro.remark || '', style: 'studentDetails' },
        ]);
    });

    pdfDoc.content[1].table.body.push([
        { text: '', style: 'studentDetails' },
        { text: 'Total', style: 'studentDetailsRight' },
        { text: '500000.25', style: 'studentDetails' },
        { text: '500000.25', style: 'studentDetails' },
        { text: '500000.25', style: 'studentDetails' },
        { text: '', style: 'studentDetails' },
    ]);
    return pdfDoc;
}



// WEBPACK FOOTER //
// ./src/utils/pdf-reports/liabilityOverallReport.js